import React, { useEffect } from "react";
import StudentAssignmentListing from "./StudentAssignmentListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems ,
  setTotalItems
} from "src/redux/slices/StudentAssignmentSlice";
import { useGetAllAssigmentsStudentQuery } from "src/services/StudentServices";
import { useParams } from "react-router-dom";
type Props = {};

const StudentAssignmentListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {studentId} = useParams()
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.studentAssignment);

  const { data, isLoading, isFetching } = useGetAllAssigmentsStudentQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["questionLabel", "studentLabel", "remark"],
    page: page,
    filterBy :[{
      fieldName : 'studentId',
      value : studentId
    }],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    { field: "name", headerName: "Name", flex: "flex-[1_1_0%]" },
    { field: "age", headerName: "Age", flex: "flex-[1_1_0%]" },
  ];

  return (
    <div>
      <StudentAssignmentListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default StudentAssignmentListingWrapper;
